var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"100%","height":"380px","position":"relative","z-index":"77"}},[_c('HomeChartBlock',{attrs:{"refId":"Highcharts6","option":_vm.option}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }